interface Props {
  onClose: () => void;
}

export const ConfirmDialog = ({ onClose }: Props) => {
  return (
    <div className="flex h-[210px] w-[336px] flex-col">
      <div className="text-2xl font-semibold text-[#000]">정보 수정 완료</div>
      <div className="mt-6 flex flex-1 text-lg text-[#3d3d3d]">
        수정 내용이 반영되었습니다.
      </div>
      <button
        onClick={onClose}
        className="mt-auto h-12 w-full rounded bg-[#00bda5] text-base font-semibold text-white"
      >
        확인
      </button>
    </div>
  );
};
